import React from "react";
import { MarginAddRule } from './addMarginRule';
import { withNavBars } from "../../../HOCs";

class MarginAddRuleParent extends React.Component {
    render() {
        return <MarginAddRule {...this.props} isEdit={true} isStepper={false}/>
    }
}
export default withNavBars(MarginAddRuleParent);